module.exports = __webpack_public_path__ + "static/media/weather.0259ca12.svg";